import script from "./AssistentePreenchimentoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistentePreenchimentoModal.vue?vue&type=script&setup=true&lang=js"

import "./AssistentePreenchimentoModal.vue?vue&type=style&index=0&id=74554920&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74554920"]])

export default __exports__